import {jsx as _jsx} from "react/jsx-runtime";import {Node} from '@tiptap/core'
import { NodeViewWrapper, ReactNodeViewRenderer} from '@tiptap/react'
import {lazy} from 'react'

import {appendColumn, appendRow, getColumns, getRows} from './data'

const DatabaseView = lazy(() => import(/* webpackChunkName: 'DatabaseView' */ './DatabaseView'))

function Component(props) {
  const {extension} = props

  return (
    _jsx(NodeViewWrapper, { className: "relative overflow-auto" , children: 
      _jsx(DatabaseView, { doc: extension.options.document,} )
    })
  )
}




export const Database = Node.create({
  name: 'database',
  onCreate() {
    // Add some initial content to make the first use easier
    const doc = this.options.document
    if (getRows(doc).length === 0) {
      if (getColumns(doc).length === 0) {
        appendColumn(doc, {name: 'Text column', type: 'text'})
        appendColumn(doc, {name: 'Number column', type: 'number'})
        appendColumn(doc, {name: 'Check column', type: 'check'})
      }
      appendRow(doc)
    }
  },
  renderHTML() {
    return ['div']
  },
  parseHTML() {
    return [{tag: 'database'}]
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component, {contentDOMElementTag: 'div'})
  }
})
